module.exports = __webpack_public_path__ + "tile-1-image-lWLmk1_.webp";